import { jsx, jsxs } from "react/jsx-runtime";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import * as React from "react";
import { cn } from "@tameeni/shared-logic";
import { Label } from "../label/label.js";
const RadioGroup = React.forwardRef(({ className, id, ...props }, ref) => {
  return /* @__PURE__ */ jsx(
    RadioGroupPrimitive.Root,
    {
      className: cn("grid gap-2", className),
      id,
      "data-testid": id,
      ...props,
      ref
    }
  );
});
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;
const RadioGroupItem = React.forwardRef(({ className, label, labelClassName, ...props }, ref) => {
  return /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2 w-fit has-[:disabled]:cursor-not-allowed", children: [
    /* @__PURE__ */ jsx(
      RadioGroupPrimitive.Item,
      {
        ref,
        className: cn(
          "peer group aspect-square h-5 w-5 rounded-full border data-[state=checked]:border-green-600 border-slate-400 enabled:hover:border-green-600 data-[state=checked]:enabled:hover:border-green-700 disabled:data-[state=checked]:border-slate-300 disabled:border-slate-400 disabled:cursor-not-allowed disabled:bg-slate-100",
          className
        ),
        ...props,
        children: /* @__PURE__ */ jsx(RadioGroupPrimitive.Indicator, { className: "group flex items-center justify-center", children: /* @__PURE__ */ jsx("div", { className: "h-3 w-3 rounded-full bg-green-600 group-disabled:bg-slate-300 group-enabled:group-hover:bg-green-700 text-current" }) })
      }
    ),
    /* @__PURE__ */ jsx(Label, { htmlFor: props.id, className: labelClassName, children: label })
  ] });
});
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;
export {
  RadioGroup,
  RadioGroupItem
};
